export function Button({ children, variant = 'primary', className = '', ...props }) {
  const base = 'inline-flex items-center justify-center px-4 py-2 rounded-xl text-sm font-medium transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed active:scale-[0.98]';
  const variants = {
    primary: 'bg-brand-gradient text-white shadow-brand hover:shadow-glow hover:-translate-y-0.5',
    secondary: 'bg-white/80 dark:bg-white/10 text-slate-700 dark:text-slate-200 ring-1 ring-slate-900/10 dark:ring-white/15 hover:bg-white dark:hover:bg-white/15 hover:ring-slate-900/15 shadow-sm',
    ghost: 'text-brand hover:bg-brand/10 dark:hover:bg-brand/20',
  };
  return (
    <button className={`${base} ${variants[variant]} ${className}`} {...props}>
      {children}
    </button>
  );
}
